import { truckDepotsOps } from "../api/operations";
import { ROLE } from "../Auth/useRole";
import { entityFactory } from "../hooks/useEntity";
import { rangeFilterUTC } from "../helpers/utils";
import { defineEntity } from "../api/entity";

const conf = defineEntity({
  ...entityFactory("truck-depots"),
  endpoint: "truck-depots",
  operations: truckDepotsOps,
  roleView: [ROLE.CUSTOMER_VIEW],
  roleAdmin: [ROLE.CUSTOMER_ADMIN],
  baseRoute: "truck-depots",
  singularName: (t) => t("Truck depot"),
  name: (t) => t("Truck depots"),

  sendCulture: true,
  initialFilter: {},
  filterFormatter: rangeFilterUTC,
  syncCustomerFilter: true,
});

export default conf;
